import {
  createContext,
  useContext,
} from "react";

import { LessonsLibrary } from "../../../lib";
import { ExtendedLesson } from "../../types";

type ContextValues = {
  currentLessonIndex: number,
  currentLesson: ExtendedLesson | null,
  prevLesson: ExtendedLesson | null,
  nextLesson: ExtendedLesson | null,
  isLastLesson: boolean,
  isNextLessonAvailable: boolean,
  isPrevLessonAvailable: boolean,
  lessonNodeIds: string[] | null,
  library: LessonsLibrary | null,
  rootNodeIds: string[] | null,
  unitsChildren: Record<string, string[]> | null,
  isCoursePassed: boolean,
  hasSuccessScreen: boolean,
  showFinishLessonButton: boolean,
};

type ContextActions = {
  nextLessonAction: () => void,
  prevLessonAction: () => void,
  setLessonAction: (index: number) => void,
  updateLibraryAction: (
    nodeId: string,
    lessonData: ExtendedLesson | Partial<ExtendedLesson>,
    overwrite?: boolean,
  ) => void,
};

const INITIAL_CONTEXT_VALUES: ContextValues = {
  currentLessonIndex: 0,
  currentLesson: null,
  prevLesson: null,
  nextLesson: null,
  isLastLesson: false,
  isNextLessonAvailable: true,
  isPrevLessonAvailable: false,
  lessonNodeIds: null,
  library: null,
  rootNodeIds: null,
  unitsChildren: null,
  isCoursePassed: false,
  hasSuccessScreen: false,
  showFinishLessonButton: false,
};

const INITIAL_CONTEXT_ACTIONS: ContextActions = {
  nextLessonAction: () => null,
  prevLessonAction: () => null,
  setLessonAction: () => null,
  updateLibraryAction: () => null,
};

export const MainContextValues = createContext(INITIAL_CONTEXT_VALUES);
export const MainContextActions = createContext(INITIAL_CONTEXT_ACTIONS);

export const useMainContextValues = () => useContext(MainContextValues);
export const useMainContextActions = () => useContext(MainContextActions);
